function fetchComments(pk, commentContainer, callback) {
    var commentURL = '/project/' + pk + '/comments/'

    var myInit = {
        method: 'GET'
    };

    var myRequest = new Request(commentURL, myInit);

    fetch(myRequest).then(function(response) {
        callback(commentContainer, response);
    }).catch(function(e){
        console.log(e);
    });
}



document.addEventListener("DOMContentLoaded", function(event) {
    var commentContainer = document.getElementById('comment-container');
    if (commentContainer) {
        let projectId = commentContainer.dataset.projectId;
        fetchComments(projectId, commentContainer, function appendComments(commentContainer, response) {
            response.text().then(function (text) {
                commentContainer.innerHTML = text; 
            });
        }); 
    }
});